import alt from 'components/Dispatcher';
import generateAsyncActions from 'utils/generateAsyncActions';
import {ActionsBase, DispatchAll, IncludeResultCallbacks} from '@store/@types/alt';
import {FetchRepPlansRequest, RepCoachingSource} from '@store/coaching-plans/rep/RepCoachingSource';
import CoachingPlan, {PlanId} from 'records/CoachingPlan';
import {List, Map} from 'immutable';
import {Int} from '@store/@types/util';
import {CoachingPlanVelocity} from 'records/CoachingPlanVelocity';

interface AsyncActions {
  fetchRepPlans(params: FetchRepPlansRequest): Promise<List<CoachingPlan>>;
  fetchTimeSpent(planIds: PlanId[]): Promise<Map<PlanId, Int>>;
  fetchVelocity(planIds: PlanId[]): Promise<List<CoachingPlanVelocity>>;
}

interface SyncActions {}

export interface RepCoachingActionsInterface
  extends IncludeResultCallbacks<AsyncActions>,
    SyncActions {}

class RepCoachingActions
  extends ActionsBase<AsyncActions, SyncActions>()
  implements DispatchAll<AsyncActions>
{
  constructor() {
    super();
    this.generateActions(
      ...generateAsyncActions<AsyncActions>('fetchRepPlans', 'fetchTimeSpent', 'fetchVelocity')
    );
  }

  fetchRepPlans(params) {
    return dispatch => {
      dispatch();
      return RepCoachingSource.fetchRepPlans(params).then(
        this.fetchRepPlansSuccess,
        this.fetchRepPlansError
      );
    };
  }

  fetchTimeSpent(planIds) {
    return dispatch => {
      dispatch();
      return RepCoachingSource.fetchTimeSpent(planIds).then(
        this.fetchTimeSpentSuccess,
        this.fetchTimeSpentError
      );
    };
  }

  fetchVelocity(planIds) {
    return dispatch => {
      dispatch();
      return RepCoachingSource.fetchVelocity(planIds).then(
        this.fetchVelocitySuccess,
        this.fetchVelocityError
      );
    };
  }
}

export default alt.createActions<AsyncActions, SyncActions>(RepCoachingActions);
